import React from 'react';
import styled from '@emotion/styled';
import Button from 'ui/elements/buttons/Button';
import ButtonList from 'ui/elements/buttons/ButtonList';
import { useReLogin } from './useLoginWithRedirect';
import { AuthFailure } from './authErrors';
import { contentSpacing, sectionSpacing } from 'ui/theme/themeConstants';

const Centered = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  min-height: 80vh;
  padding: ${sectionSpacing};
`;

const Body = styled.p`
  margin-top: ${contentSpacing};
  max-width: 28rem;
`;

const Actions = styled.div`
  margin-top: ${sectionSpacing};
`;

// The full-page counterpart to SessionExpiredDialog, for when the token failed before anything
// rendered. Without it this state was an unbreakable loading screen.
export default function SessionExpiredScreen({ failure }: { failure: AuthFailure }) {
  const reLogin = useReLogin();
  const isTerminal = failure.kind === 'terminal';

  return (
    <Centered>
      <h1 className="text-h2">{isTerminal ? "You've been logged out" : "We couldn't connect"}</h1>
      <Body className="text-body">
        {isTerminal
          ? 'Your session has expired. Log in again to continue.'
          : "We couldn't confirm that you're logged in. Check your connection and try again."}
      </Body>
      <Actions>
        <ButtonList align="center">
          {!isTerminal && (
            <Button kind="secondary" onClick={() => window.location.reload()}>
              Try again
            </Button>
          )}
          <Button kind="primary" autoFocus onClick={reLogin}>
            Log in again
          </Button>
        </ButtonList>
      </Actions>
    </Centered>
  );
}
